import "./*.scss";
import "swiper/swiper.min.css";
import "swiper/modules/pagination/pagination.min.css";
import Swiper, { Pagination } from "swiper";
import { media } from "../../assets/js/utilities/media.js";

function setup({ el }) {
  const context = el;
  const selectors = {
    ctaCarousel: "[data-swiper-cta-carousel]",
  };
  const elements = {
    ctaCarousel: context.querySelector(selectors.ctaCarousel),
  }

  Swiper.use([Pagination]);

  const swiper = new Swiper(elements.ctaCarousel, {
    spaceBetween: 25,
    loop: true,
    slidesPerView: 1.5,
    centeredSlides: true,
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true,
    },
    breakpoints: {
      [media.sizes.lg]: {
        slidesPerView: 4,
      },
      [media.sizes.md]: {
        slidesPerView: 3,
      },
      [media.sizes.xs]: {
        slidesPerView: 2,
      },
    },
  });
}

function init() {
  document.querySelectorAll("[data-module='cta-carousel']").forEach((el) => {
    setup({ el });
  });
}

export default init;
